<template>
  <v-app>
    <div class="h-100">
      <router-view />
      <confirm-modal />
    </div>
  </v-app>
</template>

<script>
import Persister from "./utils/LocalStoragePersister";
import ConfirmModal from "./components/layout/Modal/confirmModal";
/**
 * Au démarrage de l'application, on vérifie si l'utilisateur a déjà une session, autrement on le redirige vers la page de login
 */
export default {
  name: "app",
  components: { ConfirmModal },
  data() {
    return {
      freeRoutes: ["login", "change-password", "forgot-password"],
    };
  },
  async mounted() {
    let user = this.$store.state.user.informations;
    console.log('token: ', user.token);
    if (!user || !user.token) {
      user = this.getLocalStorageUser();
      console.log('token user: ', user);
      if (user) {
        await this.$store.dispatch("loginUser", user);
      }
    }
    if (!user || !user.token) {
      if (!this.freeRoutes.includes(this.$router.currentRoute.name)) {
        this.$router.push("/login");
      }
    }
  },
  methods: {
    getLocalStorageUser() {
      const token = Persister.get("user_token");
      const information = JSON.parse(Persister.get("user_information"));
      const permissions = JSON.parse(Persister.get("user_permissions"));
      if (token) {
        return Object.assign(
          {},
          {
            token,
            permissions,
          },
          information
        );
      }
      return null;
    },
  },
};
</script>